import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeDateReceiptForm from './ChangeDateReceiptForm'
import { getDateOnlyUa } from '../../../../../helpers/date/dateHelper'

const ChangeDateReceiptButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={writeOffActItem.dateReceipt ? getDateOnlyUa(writeOffActItem.dateReceipt) : ''}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування дати надходження'}
            disableClickOutside={true}
            content={
                <ChangeDateReceiptForm
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeDateReceiptButton